import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { beginDemoSession } from '../../services/accountSetup/demoSession';

export default function DemoEntry() {
  const { user, backendUser, accountSettings, loading } = useAuth();
  const { t } = useTranslation();
  const allowed = Boolean(backendUser?.demoContext || accountSettings.includes('account_setup'));
  useEffect(() => {
    if (loading || !user || !backendUser || !allowed) return;
    beginDemoSession(user.id, new URLSearchParams(window.location.search).get('tour') === '1');
    window.location.replace('/dashboard');
  }, [loading, user, backendUser, allowed]);
  return <div className="p-6 text-textPrimary dark:text-textPrimary-dark" role="status">
    {t(loading || !backendUser || allowed ? 'accountSetup.demo.loading' : 'accountSetup.demo.unavailable')}
  </div>;
}
